import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    preferences: null
}

export const pricingSlice = createSlice({
    name: 'pricing',
    initialState,
    reducers: {
        setPreference: (state, { payload }) => {
            const [k,v] = payload;
            const preferences = {...state.preferences} || {};
            preferences[k] = v;
            state.preferences = preferences;
        },
        clearPreference: (state) => {
            state.preferences = null;
        }
    }
});

export const { setPreference, clearPreference } = pricingSlice.actions;
export default pricingSlice.reducer;